import { useNavigate } from 'react-router-dom';

function CheckEmail() {
  const navigate = useNavigate();
  const email = sessionStorage.getItem('carpeRegisterEmail') || 'your email';

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.logo}>Carpe Wonder™</div>

        <div style={styles.icon}>✉️</div>

        <h1 style={styles.headline}>Check your email</h1>
        <p style={styles.subline}>
          We sent a confirmation link to <strong style={styles.email}>{email}</strong>.
          Click the link to activate your account and start planning your next trip.
        </p>

        <div style={styles.hint}>
          Did not get it? Check your spam folder or{' '}
          <button style={styles.linkBtn} onClick={() => navigate('/register')}>
            try again
          </button>
          .
        </div>

        <button style={styles.backBtn} onClick={() => navigate('/login')}>
          Back to sign in
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#0d0d1f',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '0 16px',
  },
  container: {
    width: '100%',
    maxWidth: '400px',
    paddingTop: '48px',
    paddingBottom: '48px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  logo: {
    fontSize: '14px',
    color: 'var(--gold)',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    marginBottom: '32px',
  },
  icon: {
    fontSize: '48px',
    marginBottom: '24px',
  },
  headline: {
    fontSize: '26px',
    fontWeight: '500',
    color: '#fff',
    marginBottom: '16px',
    lineHeight: '1.2',
  },
  subline: {
    fontSize: '15px',
    color: 'rgba(255,255,255,0.7)',
    lineHeight: '1.7',
    marginBottom: '32px',
    maxWidth: '320px',
  },
  email: {
    color: 'var(--gold)',
    fontWeight: '500',
  },
  hint: {
    fontSize: '13px',
    color: 'rgba(255,255,255,0.55)',
    marginBottom: '32px',
    lineHeight: '1.6',
  },
  linkBtn: {
    background: 'transparent',
    border: 'none',
    color: 'var(--gold)',
    fontSize: '13px',
    cursor: 'pointer',
    padding: '4px',
    minHeight: '44px',
  },
  backBtn: {
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: '20px',
    color: 'rgba(255,255,255,0.65)',
    fontSize: '14px',
    padding: '12px 28px',
    cursor: 'pointer',
    minHeight: '44px',
  },
};

export default CheckEmail;
